import moment from "moment"
import styles from "./LineChart.module.scss"
import * as d3 from "d3"
import { constantValues } from "src/components/shared/Charts/constant"
import { LINE_TYPE } from "src/components/shared/Charts/Helper/ChartCategories/lineChart"
import { isFunction } from "lodash"
import { nFormatter } from "../helper"

// Create Axis Method
export const createAxis = (obj, scale, shouldShowIntegersOnly = false) => {
  const axisLeft = d3.axisLeft(scale)
  const axisRight = d3.axisRight(scale)
  const rangeDiff = obj?.range?.[1] - obj?.range?.[0]
  const axis =
    obj?.axisName === "y1" || obj?.axisName === "y4" ? axisLeft : axisRight

  const getDigits = (rangeDiff) => {
    if (rangeDiff === 0) return 0
    const magnitude = Math.floor(Math.log10(rangeDiff))
    return Math.max(0, 2 - magnitude)
  }

  const tickFormat = shouldShowIntegersOnly
    ? (val) => (Number.isInteger(val) && val >= 0 ? val.toString() : "")
    : (val) => nFormatter(val, getDigits(rangeDiff))

  return {
    axis: axis
      .tickFormat(tickFormat)
      .ticks(obj?.tickCount)
      .tickSize(0)
      .tickPadding(10),
    className: styles[`axis${obj?.axisName}`]
  }
}

// Still a work in progress
export const timeXAxisLabel = (x) => {
  const date = moment(new Date(x))
  const isMidNight = date.hour() === 0 && date.minutes() === 0
  return isMidNight ? date.format("DD MMM") : date.format("hh A")
}

export const lineGenerator = (
  timestamps,
  data,
  yScale,
  xScale,
  type = LINE_TYPE
) => {
  if (isFunction(yScale) && isFunction(xScale)) {
    return d3
      .line()
      .x((timestamp: any) => xScale(new Date(timestamp)))
      .y((_: any, i: number) =>
        yScale(parseFloat(type === LINE_TYPE ? data?.[i] : data))
      )
      .defined(
        (_: any, i: number) =>
          !constantValues?.includes(type === LINE_TYPE ? data?.[i] : data)
      )(timestamps)
  } else {
    return ""
  }
}

export const plotLineGenerator = (
  xData,
  yData,
  yScale,
  xScale,
  type = LINE_TYPE
) => {
  if (isFunction(yScale) && isFunction(xScale)) {
    return d3
      .line()
      .x((data: any) => data)
      .y((_: any, i: number) => (type === LINE_TYPE ? yData?.[i] : yData))
      .defined(
        (_: any, i: number) =>
          !constantValues?.includes(type === LINE_TYPE ? yData?.[i] : yData)
      )(xData)
  } else {
    return ""
  }
}

export const analyticReferenceLineGenerator = (dataMap, yScale, xScale) => {
  if (!isFunction(yScale) || !isFunction(xScale)) {
    return ""
  }

  const dataPoints = Object.keys(dataMap)
    .sort()
    .map((dateStr) => {
      const value = dataMap[dateStr]
      return {
        x: new Date(dateStr),
        y: typeof value === "number" && !isNaN(value) ? value : null
      }
    })

  return d3
    .line<{ x: Date; y: number | null }>()
    .x((d) => xScale(d.x))
    .y((d) => yScale(d.y!))
    .defined((d) => d.y !== null)(dataPoints)
}

